import React from "react";
import Modal from "react-bootstrap/Modal";
import { DataGrid } from '@mui/x-data-grid';
import Button from "react-bootstrap/Button";

export default function LeaseList({
  _leaseList,
  showLeaseList,
  setShowLeaseList,
  leaseFieldName,
  onChange,
  
}) {


  function handleOnSelect(selectedId) {
    onChange({
      target: { value: selectedId[0], name: leaseFieldName, type: "text"  },
    });
    setShowLeaseList(false);
  } 
  debugger;
  return (
    
    <Modal
      show={showLeaseList}
      size="xl"
      onHide={() => setShowLeaseList(false)}
      dialogClassName="modal-90w modal-dialog-scrollable"
      aria-labelledby="example-custom-modal-styling-title"
      className="partner-list-modal"
    >
      <Modal.Header
        style={{
          background: "#d4e1f5",
        }}
      >
        <Modal.Title
          id="example-custom-modal-styling-title"
          style={{
            fontWeight: 700,
          }}
        >
          List of Leases
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {_leaseList?.length && (
          <div style={{ height: '50vh', width: '100%' }}>
         <DataGrid
         rows={_leaseList || []}
         columns={[
          { field: 'id', headerName: 'Lease Id', width: 250 },
          { field: 'leaseTypeId', headerName: 'Lease Type', width: 250 },
          { field: 'companyId', headerName: 'Company', width: 350 },
         ]}
         pageSize={10}
         rowsPerPageOptions={[5]}
         onSelectionModelChange={selectedId => handleOnSelect(selectedId)}
       />
       </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="offset-11 col-1">
          <Button
            variant="danger"
            onClick={() => {
              setShowLeaseList(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
